import { atom } from "recoil"
export const showAnswerData = atom({
	key: "showAnswer",
	default: false,
})
